import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { fetchSystemAlert, selectAlert, selectBannerSystemAlert } from '@actions/alerts';
import { Alert, SystemAlertDisplay as SystemAlert } from '@components/Alert';
import styles from './Alerts.module.scss';
import { useOnVisible } from '@hooks/use-on-visible';
import ImportingContactsAlert from '@components/Alert/ImportingContactsAlert';
import { useAuthContext } from '@support/hooks/use-auth-context';
import { useLocation } from 'react-router-dom';
import { selectUserHasFlag } from '@reducers/user/metadata';

export default function Alerts() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { accountProcessingStatus } = useAuthContext();
  const systemAlert = useSelector(selectBannerSystemAlert);
  const alert = useSelector(selectAlert);
  const accountProcessingToastDismissed = useSelector(
    selectUserHasFlag('accountProcessingToastDismissed'),
  );
  const forceShowImportingContactsAlert = useSelector(
    selectUserHasFlag('forceShowImportingContactsAlert'),
  );

  const accountProcessingAlert =
    location.pathname !== '/tour' &&
    !accountProcessingToastDismissed &&
    accountProcessingStatus &&
    accountProcessingStatus !== 'complete';

  useOnVisible(() => dispatch(fetchSystemAlert()));
  useEffect(() => {
    dispatch(fetchSystemAlert());
  }, []);

  const renderAlert = () => {
    if (forceShowImportingContactsAlert) {
      return <ImportingContactsAlert />;
    }

    if (systemAlert && !systemAlert.isDismissed) {
      return <SystemAlert alert={systemAlert} />;
    }

    if (accountProcessingAlert) {
      return <ImportingContactsAlert />;
    }

    return alert && <Alert type={alert.type}>{alert.text}</Alert>;
  };

  return (
    <div
      className={cn(
        styles.container,
        (systemAlert || accountProcessingAlert || alert || true) && styles.active,
      )}
    >
      {renderAlert()}
    </div>
  );
}
